import React, { useState } from 'react'
import Button from '../../Components/Button/Button'
import Input from '../../Components/Input/Input'
import Style from './UpdateCourse.module.css'
import 'react-quill/dist/quill.snow.css';
import Editor from '../../Components/Editor/Editor';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCamera, faPhotoVideo } from '@fortawesome/free-solid-svg-icons'
import Resizer from "react-image-file-resizer";
import Select from 'react-select'
import { changeCourseDetailAPI, getCourseDetailAPI, getCourseListAPI } from '../../API/AdminServices';
import { errorToast, succToast } from '../../Toast/Toast';
import { useEffect } from 'react';
import { ThreeHorseLoading } from 'react-loadingg';

const UpdateCourse = () => {
    const[courseList,setCourseList]=useState([])
    const[courseDetail,setCourseDetail]=useState()
    const[loadingPage,setLoadingPage]=useState(false)
    useEffect(()=>{
        getCourseAll()
    },[])
    const getCourseAll=async()=>{
        const data=await getCourseListAPI()
        setCourseList(data.courses)
    }
    const options = [
        courseList.map(item=>{
            return(
                {value:`${item.id}`,
                label:`${item.name}`}
            )
        })
      ]
    useEffect(()=>{
        setPrice(courseDetail===undefined?'':courseDetail.price)
        setdescription(courseDetail===undefined?'':courseDetail.description)
        setCover(courseDetail===undefined?'':courseDetail.cover)
    },[courseDetail])

    const[desc,setdescription]=useState('')
    const[price,setPrice]=useState('')
    const[cover,setCover]=useState()
    const[video,setVideo]=useState()
    const [courseId, setCourseId] = useState('');
    const[sendImage,setSendImage]=useState()
    const[selectedImage,setSelectedImage]=useState()
    const onChangeHandler=(id)=>{
        setCourseId(id.value)
        getCourseDetail(id.value)
        setLoadingPage(true)
    }
    const getCourseDetail=async(id)=>{
        const data=await getCourseDetailAPI(id)
        setCourseDetail(data.course)
        setLoadingPage(false)
    }
    
    const sendUpdateInfo=()=>{
        setLoadingPage(true)
        let info={
            id:courseId,
            description:desc,
            teacher:"محمدباقرفروغی",
            price:price,
            off_price:0,
            cover:sendImage,
            video:video
        }
        changeCourseDetailAPI(info,(res)=>{
            if(res.status===1){
                succToast(res.message)
                getCourseDetailAPI(courseId)
                setLoadingPage(false)
            }
            else{
                errorToast(res.message)
                setLoadingPage(false)
            }
        })
    }




    //////upload image////
    const UploadImage =async(e)=>{
        imageChange(e)
        try{
            const image=await resizeFile(e.target.files[0])
            setSendImage(image)
        }catch(err){
            console.log(err)
        }
    }
    const resizeFile =(file) =>{
        return new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                1024,
                1024,
                "WEBP",
                100,
                0,
                (uri) => {
                    resolve(uri)
                },
                "base64"
                )
            })
        }
        
    ///////upload video//////
    const getBase64 = (file) => {
        return new Promise(resolve => {
          let baseURL = "";
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            baseURL = reader.result;
            resolve(baseURL);
            setVideo(baseURL)
          };

        });
      };
    
    const UploadVideo = e => {
        let file = e.target.files[0];
    
        getBase64(file)
          .then(result => {
            file["base64"] = result;

          })
          .catch(err => {
            console.log(err);
          });
    

      };
      const imageChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
          setSelectedImage(e.target.files[0]);
        }
      };
    return (
        <section className={Style.PageHolder}>
            {
                loadingPage?<div className={Style.loadingHolder}><ThreeHorseLoading/></div>:null
            }
            <div className={Style.vectorHolder}><img src="./Assets/Images/Panel/Edite.svg" alt="" /></div>
            <form action="" className={Style.FormHolder}>
                <Select onChange={onChangeHandler} className={Style.selectOptionsearch} options={options[0]} placeholder={'دوره موردنظر انتخاب کنید'}/>
                <Editor
                desc={desc}
                setdescription={setdescription}
                />
                <Input placeholder={'هزینه دوره'} type={'number'} inputtype={'valid'} value={price} onChange={e=>setPrice(e.target.value)}/>
               
               
                <div className={Style.UploaderHolder}>
                <p>ویدیو معرفی خود را انتخاب کنید:</p>
                <label htmlFor="uploadImage" className={Style.LabelUpload}>
                    <FontAwesomeIcon icon={faPhotoVideo}/>
                    <p>انتخاب فایل</p>
                </label>
                <input type="file" id={"uploadImage"} style={{display:"none"}} accept="video/*" onChange={(e)=>UploadVideo(e)}/>
               </div>
                
                
                <div className={Style.ImageHolder}>
                    <div className={Style.ImagePerview}>{cover===''?<FontAwesomeIcon icon={faCamera}/>:<img src={selectedImage===undefined?`https://cdn.electronicsteps.ir/course/cover/${cover}.jpg`: URL.createObjectURL(selectedImage)} alt='electronic'/>}</div>
                    <label htmlFor="imageFile">آپلود عکس دوره</label>
                    <input  type='file' id='imageFile' style={{display:'none'}} accept="image/*" onChange={(e)=>UploadImage(e)}/>
                </div>

                <div className={Style.BtnHolder}>
                    <Button ClassBtn={'confirmBtn'} Value={'ثبت'} clickhandler={sendUpdateInfo}/>
                    <Button ClassBtn={'cancelBtn'} Value={'بازگشت'} />
                </div>
            </form>
        </section>
    )
}

export default UpdateCourse
